import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./context/ProtectedRoutePainelDeControle";

import NavBar from "./components/Header/header";
import Footer from './components/Footer/Footer'

import Home from "./pages/Home/home";
import Convenios from './pages/Convenio/Convenios'
import SobreNos from './pages/SobreNos/SobreNos'
import { FaleConosco } from './pages/FaleConosco/FaleConosco'
import Eventos from './pages/Eventos/Eventos'

import BancodeDados from "./pages/BancodeDados/BancodeDados";
import Verbetes from './components/BancoVerbetesComponents/VerbetesConteudo'
import DocumentoDoVerbete from './components/BancoVerbetesComponents/DocumentoDoVerbeteIndex'
import DashBoardDocumentos from "./components/PainelDeControle/DashBoardDocumentos";
import DocumentoAvulsoView from "./components/DocumentosPdf/DocumentoAvulsoView";

import AutoresIndex from './components/Autores/AutoresIndex'

{/* Pagina dos eventos  */ }
import VIEvento from './components/EventosComponents/eventos/VIEvento'
import VEvento from './components/EventosComponents/eventos/VEvento'
import IVEvento from './components/EventosComponents/eventos/IVEvento'
import IIIEvento from './components/EventosComponents/eventos/IIIEvento'
import IIEvento from './components/EventosComponents/eventos/IIEvento'
import Adevolucao from './components/EventosComponents/eventos/Adevolucao'
import ISeminario from './components/EventosComponents/eventos/ISeminario'
import Paleografia from './components/EventosComponents/eventos/Paleografia'

import ArtigoDetalhes from './components/DivulgacaoCientificaComponents/ArtigoDetalhes'
import ConteudoPodcast from './components/DivulgacaoCientificaComponents/Podcast/ConteudoPodcast'
import DivulgacaoCientifica from './pages/DivulgacaoCientifica/divulgacaoCientifica'
import DashboardPodcast from "./components/PainelDeControle/DashBoardPodcast";
import DashboardDivulgacaoCientifica from "./components/PainelDeControle/DashBoardDivulgacaoCinetifica";
import DashboardAutores from "./components/PainelDeControle/DashBoardAutores";
import PaineldeControle from "./components/PainelDeControle/PainelDeControleGeral";
import DashBoardVerbetes from './components/PainelDeControle/DashBoardVerbetes'
import ContagemVisualizacoes from './components/PainelDeControle/ContagemVisualizacoes'
import ContagemDocumentos from './components/PainelDeControle/ContagemDocumentos'
import VerbetesList from './components/PainelDeControle/Editores/ListagemEdicoesVerbetes'
import EditorVerbetes from './components/PainelDeControle/Editores/EditorVerbetes'
import PodcastList from './components/PainelDeControle/Editores/ListagemEdicoesPodcast'
import EditorPodcast from './components/PainelDeControle/Editores/EditorPodcast'
import EditorArtigo from './components/PainelDeControle/Editores/EditorArtigos'
import ArtigoList from './components/PainelDeControle/Editores/ListagemEdicoesArtigo'
import ListagemEdicoesDocumentos from "./components/PainelDeControle/Editores/ListagemEdicoesDocumentos";
import EditorDocumentos from "./components/PainelDeControle/Editores/EditorDocumentos";


import SearchPDF from './components/BuscaDocumentosBanco/PdfSearchPage';

{/* Pagina dos eventos  */ }


function App() {
  return (
    <div id="app" style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <AuthProvider>


        <Router>
          <NavBar />
          <div style={{ flex: 1 }}>
            {/* Defina as rotas das páginas */}
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/Convenios" element={<Convenios />} />
              <Route path="/SobreNos" element={<SobreNos />} />
              <Route path="/FaleConosco" element={<FaleConosco />} />
              <Route path="/Eventos" element={<Eventos />} />
              <Route path="/DivulgacaoCientifica" element={<DivulgacaoCientifica />} />
              <Route path="/BancodeDados" element={<BancodeDados />} />

              {/* Pagina dos visulizacao dos artigos cintificos  */}
              <Route path="/artigo/:id" element={<ArtigoDetalhes />} />
              <Route path="/podcast/:id" element={<ConteudoPodcast />} />
              {/* Pagina dos visulizacao dos artigos cintificos  */}


              <Route path="/pdf-search" element={<SearchPDF />} />

              {/* Rotas protegidas */}
              {/* Rota principal */}
              <Route path="/PainelDeControle" element={<PaineldeControle />} />
              {/* Rotas aninhadas dentro do Painel de Controle */}
              <Route path="/PainelDeControle/DashBoardArtigos" element={<ProtectedRoute><DashboardDivulgacaoCientifica /></ProtectedRoute>} />
              <Route path="/PainelDeControle/DashBoardPodcast" element={<ProtectedRoute><DashboardPodcast /></ProtectedRoute>} />
              <Route path="/PainelDeControle/DashBoardVerbetes/" element={<ProtectedRoute><DashBoardVerbetes /></ProtectedRoute>} />
              <Route path="/PainelDeControle/DashBoardAutores" element={<ProtectedRoute><DashboardAutores /></ProtectedRoute>} />
              <Route path="/PainelDeControle/DashBoardDocumentos" element={<ProtectedRoute><DashBoardDocumentos /></ProtectedRoute>} />
              <Route path="/PainelDeControle/Editores/ListagemEdicoesDocumentos" element={<ProtectedRoute><ListagemEdicoesDocumentos /></ProtectedRoute>} />
              <Route path="/PainelDeControle/Editores/EditorDocumentos/:id" element={<ProtectedRoute><EditorDocumentos /></ProtectedRoute>} />

              <Route path="/PainelDeControle/ContagemVisualizacoes" element={<ProtectedRoute><ContagemVisualizacoes /></ProtectedRoute>} />
              <Route path="/PainelDeControle/ContagemDocumentos" element={<ProtectedRoute><ContagemDocumentos /></ProtectedRoute>} />

              <Route path="PainelDeControle/Editores/ListagemEdicoesVerbetes" element={<ProtectedRoute><VerbetesList /></ProtectedRoute>} />
              <Route path="/PainelDeControle/Editores/EditorVerbetes/:id" element={<ProtectedRoute><EditorVerbetes /></ProtectedRoute>} />
              <Route path="/PainelDeControle/Editores/EditorArtigo/:id" element={<ProtectedRoute><EditorArtigo /></ProtectedRoute>} />
              <Route path="PainelDeControle/Editores/ListagemEdicoesArtigo" element={<ProtectedRoute><ArtigoList /></ProtectedRoute>} />

              <Route path="/PainelDeControle/Editores/EditorPodcast/:id" element={<ProtectedRoute><EditorPodcast /></ProtectedRoute>} />
              <Route path="PainelDeControle/Editores/ListagemEdicoesPodcast" element={<ProtectedRoute><PodcastList /></ProtectedRoute>} />

              {/* Rotas protegidas */}




              {/* Pagina dos eventos  */}
              <Route path='/I_Seminario_do_Grupo' element={<ISeminario />} />
              <Route path='/A_devocao_popular_na_Idade_Media' element={<Adevolucao />} />
              <Route path='/Curso_de_Introdução_Paleografia' element={<Paleografia />} />
              <Route path='/II_Evento_Internacional' element={<IIEvento />} />
              <Route path='/III_Evento_Internacional' element={<IIIEvento />} />
              <Route path='/IV_Evento_Internacional' element={<IVEvento />} />
              <Route path='/V_Evento_Internacional' element={<VEvento />} />
              <Route path='/VI_Evento_Internacional' element={<VIEvento />} />
              {/* Pagina dos eventos  */}

              {/* Pagina dos verbetes   */}
              <Route path='/Autores/:id' element={<AutoresIndex />} />
              <Route path='/Verbetes/:id' element={<Verbetes />} />
              <Route path='/DocumentoDoVerbete/:id' element={<DocumentoDoVerbete />} />
              <Route path='/DocumentoAvulso/:id' element={<DocumentoAvulsoView />} />
               
    
               

              {/* Pagina dos verbetes   */}


              
 
            </Routes>

            <Footer />
          </div>
        </Router>

      </AuthProvider>

    </div>


  );
}

export default App;
